import { React, useState, Fragment, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import helper from "../../../src/services/helper";
// import { ThemeProvider, StyledEngineProvider, makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TopActions from '../actions/TopActions';
import Toast from '../actions/Toasts';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import Autocomplete from '@mui/material/Autocomplete';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import apiService from '../../services/apiServices';
import dateFormats from '../../services/dateFormats';
import validationSchema from '../../services/validationSchema';
import InputController from '../../controllers/InputController';
import SelectController from '../../controllers/SelectController';
import { yupResolver } from '@hookform/resolvers/yup';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Modal from '../actions/Modal';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useParams,
} from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import { Bars } from 'react-loader-spinner';
import config from '../../config/config'
import HolidaysHistory from '../holidays/HolidaysHistory';

export default function EditWorker(props) {
  //const classes = useStyles();
  const alert = { open: false, message: '', variant: '' };
  const [toast, setToast] = useState(alert);
  const [workTypes, setWorkTypes] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [branch, setBranch] = useState([]);
  const [contracts, setContracts] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [modal, setModal] = useState({});
  const [rowId, setRowId] = useState({});
  const [loader, setLoader] = useState(true);
  const [loaderContracts, setLoaderContracts] = useState(true);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const {
    register,
    handleSubmit,
    setValue,
    control,
    watch,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(validationSchema),

  });
  const salaryTypes=[{id:0,name:""},{id:1,name:"Mujore"},{id:2,name:"Me ore"}]
  const contractExtension=[{id:0,name:""},{id:1,name:"Mujore"},{id:2,name:"Vjetore"}]

  let { id } = useParams();
  useEffect(() => {
    apiService()
      .query('getWorker', 'id=' + id)
      .then((response) => {
        if (response.success) {
          response.data[0].Birthday = dateFormats(response.data[0].Birthday);
          response.data[0].StartDate = dateFormats(response.data[0].StartDate);
          response.data[0].EndDate = dateFormats(response.data[0].EndDate);

          const fields = Object.keys(response.data[0]);
          fields.map((field) =>
            setValue(field, response.data[0][field])
          );
          apiService()
            .get('worktype')
            .then((wt) => {
              if (wt.success) {
                setWorkTypes(wt.data);
                setValue(
                  'WorkType',
                  wt.data.find(function (e) {
                    return e.id === response.data[0].WorkType;
                  })
                );
              } else {
                alert('Error:' + wt.errorMessage);
              }
            });

          getContracts();
          
          apiService()
            .get('department')
            .then((dep) => {
              if (dep.success) {
                setDepartments(dep.data);
                setValue(
                  'Department',
                  dep.data.find(function (e) {
                    return e.id === response.data[0].Department;
                  })
                );
              } else {
                alert('Error:' + dep.errorMessage);
              }
            });
            apiService()
            .get('branch')
            .then((br) => {
              if (br.success) {
                setBranch(br.data);
                setValue(
                  'BranchId',
                  br.data.find(function (e) {
                    return e.id === response.data[0].BranchId;
                  })
                );
              } else {
                alert('Error:' + br.errorMessage);
              }
            });
            setLoader(false)
        } else {
          //   alert('Error:' + response.errorMessage);
        }
        
      });
  }, []);

  const getContracts = () => {
    apiService()
      .query('getWorkerContracts', 'id=' + id)
      .then((wc) => {
        if (wc.success) {
          setContracts(wc.data)
          setLoaderContracts(false)
        } else {
          alert('Error:' + wc.errorMessage);
        }
      });
  }

  const openModal = (id) => {
    setModal({
      open: true,
      tittle: 'Delete',
      message: 'Do you want to delete this row?',
    });
    setToast({ open: false });
    setRowId(id);
  };

  const handleDelete = (id) => {
    apiService()
      .delete('workerContract', id)
      .then((response) => {
        if (response) {
          setModal({ open: false });
          setToast({
            open: true,
            message: 'U fshi me sukses!',
            variant: 'success',
          });
          getContracts()
          //setWorkers(workers.filter((worker) => worker.Id !== id));
        } else {
          setModal({ open: false });
          setToast({
            open: true,
            message: 'Ka ndodhur nje gabim!',
            variant: 'error',
          });
        }
      });
  };

  const onSubmit = (data) => {
    // data.WorkType = data.WorkType.id;
    // data.SalaryType = data.SalaryType.id;
    // data.Department = data.Department.id;
    // data.BranchId = data.BranchId.id;
    console.log(data);
    apiService()
      .put('workers', data)
      .then((response) => {
        console.log('rrr', response)
        if (response.success) {
          setToast({
            open: true,
            message: 'U ruajten me sukses!',
            variant: 'success',
          });
        } else {
          setToast({
            open: true,
            message: 'Ka ndodhur nje gabim!',
            variant: 'error',
          });
        }
      });
  };

  const setImage = (e) => {
    if (e) {
      let file = e.target.files[0]
      var reader = new FileReader()
      let src = ''
      reader.onloadend = function () {
        var data = reader.result.split(',')[1]
        src = 'data:image/png;base64,' + data
        setValue('Image', src)
      }
      reader.readAsDataURL(file)
    }
  }
  //console.log(defaultValues);
  return (
    <div className="">
      <Fragment>
        <Modal {...modal} handleDelete={() => handleDelete(rowId)} />
        <Toast {...toast} />
        <TopActions
          // newHref={`/workerlist/${id}/addworkercontract`}
          newHref={`/workerlist/addworkercontract/${id}`}
          save={handleSubmit(onSubmit)}
        />

        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Personal Data
            </Typography>
            <form>
            {loader && <div className="loader-class"><Bars
        height="70"
        width="100%"
        color="#1976d2"
        ariaLabel="bars-loading"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      /></div>}
            {!loader && <>
              <Grid container spacing={1}>
              <Grid item xs={12} sm={12} lg={12}>
                <div class="avatar-upload">
                    <div class="avatar-edit">
                      <input
                        error={errors.Image}
                        control={control}
                        onChange={(e) => setImage(e)}
                        type="file"
                        id="imageUpload"
                      />
                      <label for="imageUpload" id="imgLabel"><EditIcon /></label>
                    </div>
                    <div class="avatar-preview">
                        <div id="imagePreview"
                            style={{backgroundImage:  `url(${watch('Image') ? watch('Image') : config.avatar})`}}>
                        </div>
                    </div>
                </div>
              </Grid>
            </Grid>
              <Grid container spacing={3}>
                <TextField
                  sx={{ display: 'none' }}
                  variant="outlined"
                  id="id"
                  name="Id"
                  {...register('Id')}
                  value={id}
                />
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Numri Personal / Pasaporta"
                    error={errors.PersonalId}
                    control={control}
                    register={{ ...register('PersonalId') }}
                    name="PersonalId"
                    type="number"
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Emri"
                    error={errors.FirstName}
                    control={control}
                    register={{ ...register('FirstName') }}
                    name="FirstName"
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Emri i prindit"
                    error={errors.ParentName}
                    control={control}
                    register={{ ...register('ParentName') }}
                    name="ParentName"
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Mbiemri"
                    error={errors.LastName}
                    control={control}
                    register={{ ...register('LastName') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Datelindja"
                    error={errors.Birthday}
                    control={control}
                    type="date"
                    register={{ ...register('Birthday') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  {/* <FormLabel component="legend">Gjinia </FormLabel> */}
                  {console.log(watch('Gender'))}
                  <Controller
                    render={({ field }) => (
                      <RadioGroup row aria-label="gender" {...field} value={watch('Gender').toString()}>
                        <FormControlLabel
                          value="0"
                          control={<Radio />}
                          label="Femër"
                        />
                        <FormControlLabel
                          value="1"
                          control={<Radio />}
                          label="Mashkull"
                        />
                      </RadioGroup>
                    )}
                    name="Gender"
                    {...register('Gender')}
                    control={control}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  {/* <FormLabel component="legend">Statusi martesor </FormLabel> */}
                  <Controller
                    render={({ field }) => (
                      <RadioGroup row aria-label="MaritalStatus" {...field} value={watch('MaritalStatus').toString()}>
                        <FormControlLabel
                          value="0"
                          control={<Radio />}
                          label="Beaqar/e"
                        />
                        <FormControlLabel
                          value="1"
                          control={<Radio />}
                          label="I/e martuar"
                        />
                      </RadioGroup>
                    )}
                    name="MaritalStatus"
                    {...register('MaritalStatus')}
                    control={control}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Kualifikimi"
                    error={errors.Qualification}
                    control={control}
                    register={{ ...register('Qualification') }}
                  />
                </Grid>

                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Email"
                    error={errors.Email}
                    control={control}
                    register={{ ...register('Email') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Telefoni"
                    error={errors.Phone}
                    control={control}
                    register={{ ...register('Phone') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Adresa"
                    error={errors.Address}
                    control={control}
                    register={{ ...register('Address') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Kodi Postal"
                    error={errors.PostalCode}
                    control={control}
                    register={{ ...register('PostalCode') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Shteti"
                    error={errors.Country}
                    control={control}
                    register={{ ...register('Country') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Qyteti"
                    error={errors.Place}
                    control={control}
                    register={{ ...register('Place') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Emri i bankes"
                    error={errors.BankName}
                    control={control}
                    register={{ ...register('BankName') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Xhirollogaria"
                    error={errors.BankAccount}
                    control={control}
                    register={{ ...register('BankAccount') }}
                  />
                </Grid>
              </Grid>
              </>}
            </form>
          </CardContent>
        </Card>
        <Card style={{marginTop: 15}}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Contracts
            </Typography>
            {loader && <div className="loader-class"><Bars
              height="70"
              width="100%"
              color="#1976d2"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            /></div>}
            {!loaderContracts && <>
              <TableContainer component={Paper}>
              <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <TableCell>Nr</TableCell>
                    <TableCell>Data e fillimit</TableCell>
                    <TableCell>Data e mbarimit</TableCell>
                    <TableCell>Paga</TableCell>
                    <TableCell>Paga për orë</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {contracts
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((w, index) => (
                      <TableRow key={w.Id}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{dateFormats(w.StartDate)}</TableCell>
                        <TableCell>{dateFormats(w.EndDate)}</TableCell>
                        <TableCell>{w.BaseSalary}</TableCell>
                        <TableCell>{w.HourSalary}</TableCell>
                        <TableCell>
                          <ButtonGroup size="small">
                            <Link to={`/workerlist/editworkercontract/${w.Id}`}>
                              <Button>
                                <EditIcon />
                              </Button>
                            </Link>
                            <Button onClick={() => openModal(w.Id)}>
                              <DeleteIcon />
                            </Button>
                          </ButtonGroup>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={contracts.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
            </>}
            </CardContent>
        </Card>
        <HolidaysHistory id={id} />
      </Fragment>
    </div>
  );
}
